import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalidadeGarantiaService } from "../modalidade-garantia.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OperacaoCreditoLivreDominioModalidade } from 'src/app/model/operacao-credito-livre-dominio-modalidade';
import { OperacaoCreditoLivreDominioIndexador } from 'src/app/model/operacao-credito-livre-dominio-indexador';
import { TaxaAtualizacaoGarantiaDTO } from 'src/app/model/dominio-operacao.model';
import { MensagemService } from '../../mensagem.service';

@Component({
    selector: 'app-modal-encerrar-taxa-atualizacao-garantia',
    templateUrl: './modal-encerrar-taxa-atualizacao-garantia.component.html',
    styleUrls: ['./modal-encerrar-taxa-atualizacao-garantia.component.scss'],
    standalone: false
})

export class ModalEncerrarTaxaAtualizacaoGarantiaComponent implements OnInit {
  public percentual: number;
  public hoje = new Date();
  public dataFinalValidade: Date;
  @Input() dataInicioValidade: Date;
  @Input() idTag: number;

  constructor(
    public activeModal: NgbActiveModal, 
    private modalidadeService: ModalidadeGarantiaService,
    private mensagemService: MensagemService,    
  ) {}

  ngOnInit(): void {}

  salvar() {
    this.modalidadeService.encerrarTaxaAtualizacaoGarantia(
      this.idTag, this.dataFinalValidade)
        .subscribe(() => {
          this.fecharAposSalvar();
          this.mensagemService.adicionarMensagemSucesso("Taxa de Atualização de Garantia encerrada com sucesso.");
        }, (error) => {
      this.mensagemService.adicionarMensagemErro('Erro ao tentar encerrar Taxa de Atualização de Garantia.');
    })
  }

  fechar() {
    this.activeModal.close({botao: 'fechar', valor: null});
  }

  fecharAposSalvar() {
    this.activeModal.close({botao: 'salvar', valor: null});
  }

}
